import React from 'react'

const ListasStyle = ({ header, children }) => {
  return (
    <div className="px-3 mx-auto mb-8 bg-white rounded-md md:max-w-screen-sm sm:px-8 border-1">
      <div className="listas-home-block__title">{header}</div>
      <div className="listas-home-block__list">{children}</div>
    </div>
  )
}

export default ListasStyle
